import { Button, Link } from "@shapr3d/frontend-lib";

import useTranslation from "../../hooks/useTranslation";

import style from "./ModelViewerWarningPage.module.css";

interface ModelViewerWarningPageProps {
  onDismissWarning: () => void;
  backgroundImage?: string;
}

export function ModelViewerWarningPage({
  onDismissWarning,
  backgroundImage,
}: ModelViewerWarningPageProps) {
  const { t, m } = useTranslation();
  return (
    <div className={style.container}>
      {backgroundImage && (
        <>
          <img
            src={backgroundImage}
            alt={t(m.ModelViewerWarning.BackgroundImageAlt)}
            className={style.backgroundImage}
          />
          <div className={style.overlay} />
        </>
      )}
      <div className={style.content}>
        <h1 className={style.title}>{t(m.ModelViewerWarning.ComplexModelTitle)}</h1>
        <p className={style.description}>{t(m.ModelViewerWarning.Description)}</p>
        <Button onClick={onDismissWarning} variant="grayscale">
          {t(m.ModelViewerWarning.LoadModel)}
        </Button>
        <Link className={style.learnMore} href="https://support.shapr3d.com/" target="_blank">
          {t(m.ModelViewerWarning.LearnMore)}
        </Link>
      </div>
    </div>
  );
}
